import { mapValues, unary } from 'lodash'

import NewHomeStepContainer from './NewHomeStepContainer'
import EnterAddress from './EnterAddress'
import EnterPurchaseDate from './EnterPurchaseDate'
import CreateHome from './CreateHome'

export default mapValues(
  {
    EnterAddress,
    EnterPurchaseDate,
    CreateHome
  },
  unary(NewHomeStepContainer)
)
